(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];

  const cartDrawer = qs("[data-cart-drawer]");
  const searchModal = qs("[data-search-modal]");

  const openCart = () => cartDrawer?.classList.add("is-open");
  const closeCart = () => cartDrawer?.classList.remove("is-open");
  const openSearch = () => searchModal?.classList.add("is-open");
  const closeSearch = () => searchModal?.classList.remove("is-open");

  const header = qs("[data-header]");
  const menuItems = qsa(".header-item.has-panel", header || document);
  let menuTimer;
  const closeMenus = () => menuItems.forEach((item) => item.classList.remove("is-open"));
  menuItems.forEach((item) => {
    const open = () => {
      clearTimeout(menuTimer);
      closeMenus();
      item.classList.add("is-open");
    };
    item.addEventListener("mouseenter", open);
    item.addEventListener("focusin", open);
  });
  header?.addEventListener("mouseenter", () => clearTimeout(menuTimer));
  header?.addEventListener("mouseleave", () => {
    menuTimer = setTimeout(closeMenus, 220);
  });

  const mobileNav = qs("[data-mobile-nav]");
  qsa("[data-open-menu]").forEach((el) => el.addEventListener("click", () => mobileNav?.classList.add("is-open")));
  qsa("[data-close-menu]").forEach((el) => el.addEventListener("click", () => mobileNav?.classList.remove("is-open")));

  qsa("[data-open-cart]").forEach((el) => el.addEventListener("click", openCart));
  qsa("[data-close-cart]").forEach((el) => el.addEventListener("click", closeCart));
  qsa("[data-open-search]").forEach((el) => el.addEventListener("click", openSearch));
  qsa("[data-close-search]").forEach((el) => el.addEventListener("click", closeSearch));

  qsa("[data-tabs]").forEach((root) => {
    const buttons = qsa("[data-tab]", root);
    const panels = qsa("[data-tab-panel]", root);
    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("data-tab");
        buttons.forEach((b) => b.classList.toggle("is-active", b === btn));
        panels.forEach((p) => {
          p.hidden = p.getAttribute("data-tab-panel") !== id;
        });
        const follow = root.parentElement?.querySelector("[data-follow-tab]") || root.querySelector("[data-follow-tab]");
        const url = btn.getAttribute("data-url");
        if (follow && url) follow.setAttribute("href", url);
      });
    });
  });

  const catalog = qs("[data-catalog]");
  qsa("[data-open-filters]").forEach((el) => el.addEventListener("click", () => catalog?.classList.add("is-filters")));
  qsa("[data-close-filters]").forEach((el) => el.addEventListener("click", () => catalog?.classList.remove("is-filters")));

  qsa("[data-filter-form]").forEach((form) => {
    const toCents = () => {
      form.querySelectorAll("[data-price]").forEach((input) => {
        const raw = input.value.trim().replace(",", ".");
        if (!raw) {
          input.disabled = true;
          return;
        }
        const amount = Number(raw);
        input.value = Number.isFinite(amount) ? String(Math.round(amount * 100)) : "";
        if (!input.value) input.disabled = true;
      });
    };
    form.addEventListener("submit", toCents);
    form.querySelectorAll("[data-filter-check]").forEach((input) => {
      input.addEventListener("change", () => {
        toCents();
        form.submit();
      });
    });
  });

  qsa("[data-scroll]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const rail = btn.closest("[data-rail]");
      const scroller = rail?.querySelector("[data-scroller]");
      if (!scroller) return;
      const dir = Number(btn.getAttribute("data-scroll")) || 1;
      const amount = Math.max(scroller.clientWidth * 0.85, 240);
      scroller.scrollBy({ left: dir * amount, behavior: "smooth" });
    });
  });

  const money = (cents) =>
    new Intl.NumberFormat("nl-BE", { style: "currency", currency: window.Shopify?.currency?.active || "EUR" }).format(
      (Number(cents) || 0) / 100
    );

  const showPrice = (cents, compare) =>
    `<span class="price">${money(cents)}${compare > cents ? `<s>${money(compare)}</s>` : ""}</span>`;

  const variantKeys = (variant) =>
    [...(variant.options || []), variant.title || "", variant.sku || ""]
      .flatMap((value) => String(value).split("/"))
      .map((value) => value.toLowerCase().trim())
      .filter((value) => value && value !== "default title" && value.length > 1)
      .sort((a, b) => b.length - a.length);

  const showVariantMedia = (gallery, variant, scroll) => {
    if (!gallery || !variant) return;
    const main = qs("[data-gallery-main]", gallery);
    const thumbs = [...gallery.querySelectorAll("[data-gallery-thumb]")];
    const id = String(variant.id);
    const keys = variantKeys(variant);
    thumbs.forEach((thumb) => {
      thumb.hidden = false;
    });
    const visible = thumbs;
    const named = (thumb) => {
      const alt = `${thumb.dataset.alt || ""} ${decodeURIComponent(thumb.dataset.src || "")}`.toLowerCase();
      return keys.some((key) => alt.includes(key) || alt.includes(key.replace(/\s+/g, "-")));
    };
    const match =
      visible.find(
        (thumb) =>
          (variant.mediaId && thumb.dataset.mediaId === String(variant.mediaId)) ||
          (variant.imageId &&
            (thumb.dataset.imageId === String(variant.imageId) || thumb.dataset.mediaId === String(variant.imageId)))
      ) || visible.find(named);
    thumbs.forEach((thumb) => thumb.classList.toggle("is-active", thumb === match));
    if (main && variant.image) main.src = variant.image;
    else if (main && match) main.src = match.dataset.src;
    if (match && scroll) match.scrollIntoView({ block: "nearest", inline: "nearest" });
  };

  qsa("[data-product]").forEach((root) => {
    const raw = qs("[data-variants]", root);
    if (!raw) return;
    let variants = [];
    try { variants = JSON.parse(raw.textContent); } catch (e) { return; }
    const gallery = qs("[data-gallery]", root);
    const idInput = qs("[data-variant-id]", root);
    const now = qs("[data-price-now]", root);
    const was = qs("[data-price-was]", root);
    const pill = qs("[data-save-pill]", root);
    const badge = qs("[data-save-badge]", root);
    const addPrice = qs("[data-add-price]", root);
    const sticky = qs("[data-sticky-price]");
    const saveLabel = root.dataset.saveLabel || "Bespaar";
    const qtyInput = qs("[data-qty] input", root);
    const qty = () => Math.max(1, Number(qtyInput?.value) || 1);
    let current = variants.find((item) => idInput && String(item.id) === String(idInput.value)) || variants[0];

    // Bundle builder (desk pages): ticked extras add to the button price and the bundle total.
    // Nothing is pre-ticked — EU consumer law forbids pre-selected paid extras.
    const bundle = qs("[data-bundle]", root);
    const bundleItems = bundle ? qsa("[data-bundle-item]", bundle) : [];
    const addLabelEl = qs(".p-add span:first-child", root);
    const baseAddLabel = addLabelEl?.textContent || "";
    const ticked = () => bundleItems.filter((item) => qs("[data-bundle-check]", item)?.checked);
    const addonCents = () =>
      ticked().reduce((sum, item) => sum + Number(qs("[data-bundle-variant]", item)?.dataset.price || 0), 0);

    const paint = (variant, scroll) => {
      if (!variant) return;
      current = variant;
      const count = qty();
      const price = variant.price * count;
      const compare = (variant.compare || 0) * count;
      const addons = addonCents() * count;
      if (idInput) idInput.value = variant.id;
      if (now) now.textContent = money(price);
      if (addPrice) addPrice.textContent = money(price + addons);
      if (bundle) {
        const sum = qs("[data-bundle-sum]", bundle);
        const n = ticked().length;
        if (sum) sum.hidden = n === 0;
        const total = qs("[data-bundle-total]", bundle);
        if (total) total.textContent = money(price + addons);
        const countEl = qs("[data-bundle-count]", bundle);
        if (countEl) countEl.textContent = `bureau + ${n} ${n === 1 ? "extra" : "extra's"}`;
        if (addLabelEl) addLabelEl.textContent = n ? "Bundel in winkelwagen" : baseAddLabel;
        bundle.classList.toggle("has-picks", n > 0);
      }
      const save = compare > price ? compare - price : 0;
      if (was) {
        was.hidden = save <= 0;
        if (save > 0) was.textContent = money(compare);
      }
      const saveText = `${saveLabel} ${money(save)}`;
      if (pill) {
        pill.hidden = save <= 0;
        pill.textContent = saveText;
      }
      if (badge) {
        badge.hidden = save <= 0;
        badge.textContent = saveText;
      }
      if (sticky) sticky.innerHTML = showPrice(price, compare);
      showVariantMedia(gallery, variant, scroll);
    };

    const setQty = (next) => {
      if (qtyInput) qtyInput.value = Math.max(1, next);
      if (current) paint(current, false);
    };
    qs("[data-qty-minus]", root)?.addEventListener("click", () => setQty(qty() - 1));
    qs("[data-qty-plus]", root)?.addEventListener("click", () => setQty(qty() + 1));
    qtyInput?.addEventListener("input", () => {
      if (qtyInput.value !== "" && Number(qtyInput.value) < 1) qtyInput.value = 1;
      if (current) paint(current, false);
    });

    qsa("[data-option-group]", root).forEach((group) => {
      qsa("[data-option-value]", group).forEach((button) => {
        button.addEventListener("click", () => {
          const index = Number(group.dataset.optionIndex);
          const next = (current?.options || []).slice();
          next[index] = button.dataset.optionValue;
          let variant = variants.find((item) => item.options.every((value, i) => value === next[i]));
          if (!variant) variant = variants.find((item) => item.options[index] === button.dataset.optionValue);
          if (!variant) return;
          qsa("[data-option-group]", root).forEach((box) => {
            const i = Number(box.dataset.optionIndex);
            qsa("[data-option-value]", box).forEach((item) => {
              item.classList.toggle("is-on", item.dataset.optionValue === variant.options[i]);
            });
          });
          paint(variant, true);
        });
      });
    });
    bundleItems.forEach((item) => {
      const check = qs("[data-bundle-check]", item);
      check?.addEventListener("change", () => {
        item.classList.toggle("is-on", check.checked);
        // the mat only makes sense with a walking pad
        if (item.dataset.bundleItem === "pad") {
          bundleItems
            .filter((other) => other.dataset.needs === "pad")
            .forEach((other) => {
              const c = qs("[data-bundle-check]", other);
              if (!c) return;
              if (!check.checked) { c.checked = false; other.classList.remove("is-on"); }
              c.disabled = !check.checked;
              other.classList.toggle("is-locked", !check.checked);
            });
        }
        if (current) paint(current, false);
      });
      if (item.dataset.needs === "pad") {
        const c = qs("[data-bundle-check]", item);
        if (c) c.disabled = true;
        item.classList.add("is-locked");
      }
      qsa("[data-model]", item).forEach((model) => {
        model.addEventListener("click", () => {
          qsa("[data-model]", item).forEach((m) => {
            m.classList.toggle("is-on", m === model);
            m.setAttribute("aria-checked", m === model ? "true" : "false");
          });
          const hidden = qs("[data-bundle-variant]", item);
          if (hidden) { hidden.value = model.dataset.variant; hidden.dataset.price = model.dataset.price; }
          const name = qs("[data-bundle-name]", item);
          if (name) name.textContent = model.dataset.name;
          const img = qs("[data-bundle-img]", item);
          if (img && model.dataset.img) img.src = model.dataset.img;
          const tag = qs("[data-bundle-price]", item);
          if (tag) tag.textContent = `+ ${money(model.dataset.price)}`;
          // picking a model is an explicit choice for the pad
          if (check && !check.checked) { check.checked = true; check.dispatchEvent(new Event("change")); }
          else if (current) paint(current, false);
        });
      });
    });

    if (current) paint(current, false);
  });

  qsa("[data-gallery]").forEach((root) => {
    const main = qs("[data-gallery-main]", root);
    const thumbs = qsa("[data-gallery-thumb]", root);
    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        if (thumb.hidden) return;
        if (main) {
          main.src = thumb.dataset.src;
          if (thumb.dataset.alt) main.alt = thumb.dataset.alt;
        }
        thumbs.forEach((item) => item.classList.toggle("is-active", item === thumb));
      });
    });
    const move = (dir) => {
      const visible = thumbs.filter((thumb) => !thumb.hidden);
      if (!visible.length) return;
      const current = Math.max(0, visible.findIndex((thumb) => thumb.classList.contains("is-active")));
      visible[(current + dir + visible.length) % visible.length].click();
    };
    qs("[data-gallery-prev]", root)?.addEventListener("click", () => move(-1));
    qs("[data-gallery-next]", root)?.addEventListener("click", () => move(1));
  });

  qsa("[data-qty]").forEach((root) => {
    if (root.closest("[data-product]")) return;
    const input = qs("input", root);
    qs("[data-qty-minus]", root)?.addEventListener("click", () => {
      input.value = Math.max(1, Number(input.value) - 1);
    });
    qs("[data-qty-plus]", root)?.addEventListener("click", () => {
      input.value = Number(input.value) + 1;
    });
  });

  // ---- bundles ---------------------------------------------------------------------------------
  // Lines added together carry the hidden `_bundle` property; the drawer and the cart page group
  // on it. The house checkout re-prices by variant id and ignores properties, so this is display
  // only and cannot change what a buyer pays.
  let bundleCfg = {};
  try { bundleCfg = JSON.parse(qs("[data-bundle-config]")?.textContent || "{}"); } catch (e) {}
  const DESK_TYPE = "Zit-Sta Bureau";
  const PAD_TYPE = "Loopband";
  const bundleOf = (item) => (item.properties && item.properties._bundle) || "";
  const newBundleId = () => "B" + Date.now().toString(36) + Math.random().toString(36).slice(2, 5);

  const bundleGroups = (cart) => {
    const out = [];
    const seen = {};
    cart.items.forEach((item) => {
      const b = bundleOf(item);
      if (!b) { out.push({ bundle: "", items: [item] }); return; }
      if (seen[b]) { seen[b].items.push(item); return; }
      seen[b] = { bundle: b, items: [item] };
      out.push(seen[b]);
    });
    // inside a bundle: desk first, then the pad, then the rest
    const rank = (i) => (i.product_type === DESK_TYPE ? 0 : i.product_type === PAD_TYPE ? 1 : 2);
    out.forEach((g) => g.bundle && g.items.sort((a, b) => rank(a) - rank(b)));
    // a "bundle" of one line (the rest was removed) is just a line again
    return out.map((g) => (g.bundle && g.items.length < 2 ? { bundle: "", items: g.items } : g));
  };

  // The single most useful add-on for what is in the cart: a desk without a pad gets the pad,
  // a pad without a mat gets the mat.
  const pickUpsell = (cart) => {
    if (!bundleCfg.enabled) return null;
    const has = (fn) => cart.items.some(fn);
    const desk = cart.items.find((i) => i.product_type === DESK_TYPE);
    const pad = cart.items.find((i) => i.product_type === PAD_TYPE);
    if (desk && !pad && bundleCfg.pad) return { offer: bundleCfg.pad, anchor: desk, line: "Loop terwijl je werkt — schuift onder je bureau." };
    if (pad && bundleCfg.mat && !has((i) => i.variant_id === bundleCfg.mat.id))
      return { offer: bundleCfg.mat, anchor: pad, line: "Beschermt je vloer en dempt het geluid." };
    return null;
  };

  const upsellHtml = (cart) => {
    const u = pickUpsell(cart);
    if (!u) return "";
    return `<li class="cart-upsell">
      <p class="cart-upsell-eyebrow">${bundleCfg.upsell || "Vaak samen gekocht"}</p>
      <div class="cart-upsell-row">
        <img src="${u.offer.img || ""}" alt="" width="56" height="56">
        <div>
          <strong>${u.offer.title}</strong>
          <span class="muted">${u.line}</span>
        </div>
        <button type="button" class="cart-upsell-add" data-upsell-add="${u.offer.id}" data-anchor="${u.anchor.key}">
          + ${money(u.offer.price)}
        </button>
      </div>
    </li>`;
  };

  const postJSON = (url, body) =>
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body),
    }).then(async (r) => {
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.description || j.message || "Dit product kon niet worden toegevoegd.");
      return j;
    });

  // Add an upsell and tie it to the line it belongs with (desk or pad), so the cart shows the two
  // as one bundle. Re-tagging the anchor line goes through /cart/change.js with its properties.
  const addUpsell = async (variantId, anchorKey) => {
    const cart = await fetch("/cart.js", { credentials: "same-origin" }).then((r) => r.json());
    const anchor = cart.items.find((i) => i.key === anchorKey);
    let bid = anchor ? bundleOf(anchor) : "";
    if (anchor && !bid) {
      bid = newBundleId();
      await postJSON("/cart/change.js", {
        id: anchor.key,
        quantity: anchor.quantity,
        properties: Object.assign({}, anchor.properties || {}, { _bundle: bid }),
      });
    }
    await postJSON("/cart/add.js", {
      items: [{ id: Number(variantId), quantity: 1, properties: bid ? { _bundle: bid } : {} }],
    });
  };

  const renderCart = (cart) => {
    const countEls = qsa("[data-cart-count]");
    countEls.forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count < 1;
    });
    const drawer = qs("[data-cart-drawer]") || document;
    const body = qs("[data-cart-body]", drawer);
    const empty = qs("[data-cart-empty]", drawer);
    const footer = qs("[data-cart-footer]", drawer);
    const subtotal = qs("[data-cart-subtotal]", drawer);
    if (!body) return;
    if (cart.item_count === 0) {
      if (empty) { empty.hidden = false; empty.style.display = "flex"; }
      if (footer) footer.hidden = true;
      body.innerHTML = "";
      return;
    }
    if (empty) { empty.hidden = true; empty.style.display = "none"; }
    if (footer) footer.hidden = false;
    const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
    const lineHtml = (item) => `
      <li class="cart-line" data-key="${item.key}">
        <img src="${item.image || ""}" alt="" width="80" height="80">
        <div>
          <p class="font-heading" style="font-size:16px;font-weight:700">${esc(item.product_title)}</p>
          ${item.variant_title && item.variant_title !== "Default Title" && item.variant_title !== "Standaard" ? `<p class="muted cart-variant">${esc(item.variant_title)}</p>` : ""}
          <p>${money(item.final_line_price)}</p>
          <div class="qty" data-qty>
            <button type="button" data-qty-change="-1">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-qty-change="1">+</button>
          </div>
          <button type="button" class="cart-remove" data-remove>${window.themeStrings?.remove || "Verwijderen"}</button>
        </div>
      </li>`;
    const groups = bundleGroups(cart);
    body.innerHTML =
      groups
        .map((g) =>
          g.bundle
            ? `<li class="cart-bundle">
                <div class="cart-bundle-head">
                  ${bundleCfg.cover ? `<img class="cart-bundle-cover" src="${bundleCfg.cover}" alt="">` : ""}
                  <div>
                    <span class="cart-bundle-tag">Bundel · ${g.items.length} producten</span>
                    <p class="font-heading cart-bundle-title">${esc(bundleCfg.title || "Jouw beweegwerkplek")}</p>
                    <p class="cart-bundle-total">${money(g.items.reduce((s, i) => s + i.final_line_price, 0))}</p>
                  </div>
                </div>
                <ul class="cart-bundle-lines">${g.items.map(lineHtml).join("")}</ul>
                <button type="button" class="cart-remove cart-bundle-remove" data-remove-bundle="${esc(g.bundle)}">Bundel verwijderen</button>
              </li>`
            : g.items.map(lineHtml).join("")
        )
        .join("") + upsellHtml(cart);
    if (subtotal) subtotal.textContent = money(cart.total_price);
  };

  const refreshCart = () =>
    fetch("/cart.js")
      .then((r) => r.json())
      .then(renderCart);

  const onCartPage = () => document.body.classList.contains("template-cart");

  document.addEventListener("click", async (event) => {
    const upsell = event.target.closest("[data-upsell-add]");
    if (upsell) {
      event.preventDefault();
      if (upsell.disabled) return;
      upsell.disabled = true;
      upsell.classList.add("is-busy");
      try {
        await addUpsell(upsell.dataset.upsellAdd, upsell.dataset.anchor);
        if (onCartPage()) { window.location.reload(); return; }
        await refreshCart();
      } catch (e) {
        alert(e.message);
        upsell.disabled = false;
        upsell.classList.remove("is-busy");
      }
      return;
    }
    const dropBundle = event.target.closest("[data-remove-bundle]");
    if (dropBundle) {
      event.preventDefault();
      const cart = await fetch("/cart.js", { credentials: "same-origin" }).then((r) => r.json());
      const updates = {};
      cart.items.filter((i) => bundleOf(i) === dropBundle.dataset.removeBundle).forEach((i) => { updates[i.key] = 0; });
      await postJSON("/cart/update.js", { updates });
      if (onCartPage()) { window.location.reload(); return; }
      refreshCart();
      return;
    }
    const change = event.target.closest("[data-qty-change]");
    const remove = event.target.closest("[data-remove]");
    const line = event.target.closest("[data-key]");
    if ((change || remove) && line) {
      const key = line.getAttribute("data-key");
      const qty = remove ? 0 : Number(line.querySelector("span").textContent) + Number(change.dataset.qtyChange);
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }),
      });
      refreshCart();
    }
  });

  qsa("form[action$='/cart/add']").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const btn = form.querySelector("[type=submit]");
      if (btn) btn.disabled = true;
      try {
        const bundleEl = form.querySelector("[data-bundle]");
        const extras = bundleEl
          ? qsa("[data-bundle-item]", bundleEl)
              .filter((item) => qs("[data-bundle-check]", item)?.checked)
              .map((item) => Number(qs("[data-bundle-variant]", item)?.value))
              .filter(Boolean)
          : [];
        let res;
        if (extras.length) {
          const bid = newBundleId();
          const count = Math.max(1, Number(data.get("quantity")) || 1);
          const items = [Number(data.get("id")), ...extras].map((id) => ({ id, quantity: count, properties: { _bundle: bid } }));
          res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items }),
          });
        } else {
          res = await fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: data });
        }
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          alert(err.description || err.message || "Dit product kon niet worden toegevoegd.");
          return;
        }
        await refreshCart();
        openCart();
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  });

  refreshCart();
})();
